var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightThemeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-1399.000000, -699.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(286.000000, 678.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1126.000000, 34.000000) scale(-1, 1) translate(-1126.000000, -34.000000) translate(1113.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F6931E",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "Menu-Icon",
    transform: "translate(8.000000, 7.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-arrow-left",
    transform: "translate(0.714286, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Icon-Color",
    points: "6.18247838 0 0 6 6.18247838 12 7.71428571 10.5134046 3.06361466 6 7.71428571 1.48659541"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightThemeArrow);
export default __webpack_public_path__ + "static/media/right-theme-arrow.996f3b89062299067cef4c4fa4133c82.svg";
export { ForwardRef as ReactComponent };